'use client';
import { isBrowser } from './isBrowser.js';

/**
 * Проверяет, запущено ли приложение в режиме "standalone".
 */ const isStandalone = isBrowser && ('standalone' in window.navigator && window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches);

export { isStandalone };
//# sourceMappingURL=isStandalone.js.map
